import { render, staticRenderFns } from "./DocumentLimitTransaction.vue?vue&type=template&id=2f1893e6&"
import script from "./DocumentLimitTransaction.vue?vue&type=script&lang=js&"
export * from "./DocumentLimitTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports